/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ChatCircle(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128.00146,24.002A104.02442,104.02442,0,0,0,36.814,178.041l-8.55468,29.91406a16.00544,16.00544,0,0,0,19.78125,19.78125l29.91406-8.54688A104.00785,104.00785,0,1,0,128.00146,24.002Z" />
    </Svg>
  );
}

export default ChatCircle;
